import commonRes from '../abstract.resource';
import {readLocation} from '../serializers/location.serializer';

const mod = angular.module('app.common.resources.location', [commonRes])

.factory('LocationResource', function (AbstractResource) {
  class LocationResource extends AbstractResource {
    constructor() {
      super('locations', LocationResource.fromBackend, true);
    }

    /**
     * Parse a location retrieved from the backend.
     * @param {Object} o
     * @returns {Location}
     */
    static fromBackend(o) {
      return readLocation(o).makeImmutable();
    }
  }

  return new LocationResource();
});

export default mod.name;
